<template>
    <section v-if="showMatchIt && banner" id="fotw_outer" class="dd-m-banner dd-m-banner--match-it">
        <div v-if="isLoading">
            <loading type="bannertop"></loading>
        </div>
		<div v-if="false">
		    <loading type="bannertop"></loading>
		</div>

        <div class="fotw_search_outer">
			<div class="match-it-left">
				<img class="match_hero match_hero_desktop" :src="banner.image.desktop">
				<img class="match_hero match_hero_mobile" :src="banner.image.mobile">
				<!-- <img class="match_circle" src="/images/matchit-circle.png"> -->
			</div>
			<div class="match-it-right">
				<h2 class="banner-main-title">{{banner.title}}</h2>
				<span class="banner-main-subtitle">{{banner.description}}</span>

				<div class="search_box" v-on:keydown='handleAutocomplete'>
					<div class='search-spinner' v-show="isSearching">
						<img src="/images/waiting.svg" />
					</div> 
					<v-autocomplete
						ref="fotw_autocomplete"
						
						:placeholder="getTranslateString('What is your favourite fragrance?')"
						:items="results"
						:min-len="2"
						v-model="search"
						:get-label="getLabel"
						:auto-select-one-item="false"
						:component-item="itemTemplate"
						input-class="dd-search-value dd-m-search__input"
						@item-selected="itemSelected"
						@update-items="updateItems">
					</v-autocomplete>

					<button
							type="button"
							@click="doSearch()"
							class="dd-m-button dd-m-button--dark dd-m-button--tiny dd-m-helper--centralize">
						<i class="dd-m-icon icon-search"></i>
					</button>
				</div>

				<img class="match_copy" src="/images/matchit-copy.png">  
			</div>
        </div>
    </section>

</template>

<script>
	import ItemTemplate from "./search/itemTemplate";
    import Loading from "./loading";
	import FotwService from "../providers/api/fotw-service";
	import BannerService from "../providers/api/banner-service";
	let bannerService = new BannerService();
		
	var fotwService = new FotwService();

	var debounce = function(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

    export default {
        name: 'match-it',
        components: {Loading},
        props: [
            'perPage'
        ],
        data: () => {
            return {
            	lang: '',
            	banner: false,
            	showMatchIt: window.showMatchIt,
            	tryy: 0,
            	selectedItem: false,
            	itemTemplate: ItemTemplate,
            	search: null,
                results: [],
                isLoading: false,
                isSearching: false,
                show: true,
                params: {
                    term: "",
                    page: 1,
                    perPage: 5
                }
            }
        },        
        mounted() {
            //this.doGetList();
            //this.isLoading = false;
            this.loadBanner();
            
            this.lang = language !== 'en' ? '/' + language : '';

        },
        methods: {

			loadBanner(){
				this.isLoading = false;

				const params = {
					perPage: 1
				};
				bannerService.doGetByType(101, params).then((res) => {
					this.banner = res.data.data[0];
					this.isLoading = false;
				})
				.catch(() => this.isLoading = false);
			},


       		handleAutocomplete(e){
       			if(e.keyCode==13){
       				return false;
       			}
       		}, 
        	doSearch(){
        		return false;
        		
        	},
            updateItems: debounce(function(text) {
				this.params.term = text;
				this.isSearching = true;
				fotwService.search(this.params).then((res)=>{
					if(res.data.success){
						this.results = res.data.data;
						this.tryy = 0;
					}else{
						this.tryy++;
						if(this.tryy>=1){
							this.tryy = 0;
							return false;
						}
						this.updateItems(text);
					}
					this.isSearching = false;
				});               
				
				return;
                
            }, 1000),            
            itemSelected(item) {
            	var gg = "";
            	switch(item.gender){
            		case 'Masculine':
            			//gg = "&categories=he";
            		break;
            		case 'Feminine':
            			//gg = "&categories=she";
            		break;
            		default:
            			gg = "";
            		break;
            	}
            
            	this.selectedItem = item;
            	window.location = this.getLink(`/fotw?q=${item.name}&fotw=${item.id}`+gg)
            },
            getLink(link) {
                if (link.indexOf('http') !== -1) {
                    return link;
                } else {
                    return (this.lang + '/' + link).replace('//', '/');
                }
            },


            getLabel(item) {
                if (!item) return;
                return item.name;
            },
            doGetList() {
                const params = {
                    perPage: this.perPage ? this.perPage : ''
                };
            },
        }
    }
</script>
<style>
	.search_box {
		position: relative;
	}
	.search-spinner {
		position: absolute;
		top: 3px;
		right: 7px;
		bottom: 0;
		width: 30px;
		height: 30px;
		background-color: #fff;
		z-index: 2;
		border-radius: 100%;
		overflow: hidden;
	}

	.search-spinner img {
		display: block;
		width: 100%;
		animation: search-spin infinite 0.5s ease;
	}

	@keyframes search-spin  {
		to {
			transform: rotate(360deg);
		}
	}

	#fotw_outer .v-autocomplete-list {
		width: 100%;
		max-width: 441px;
		max-height: 150px;
		overflow: auto;
	}

	#fotw_outer{
		overflow: visible;
		position: relative;
		z-index: 1;
	}

	.fotw_search_outer{
		position: relative;
	}
	
	#fotw_outer .v-autocomplete .v-autocomplete-list {
		position: absolute;
		z-index: 9999;
		left: 16px;
		width: 107%;
	
	}
	
	#fotw_outer .search_box button{
		pointer-events: none;
	}
	
	.search_box button{
		color: #5E5A53;
		background: #fff;
		border-radius: 0 25px 25px 0;
		border: 1px solid #7f28c4;
		border-left: none;
		position: relative;	
	}

	.search_box button:before{
		content: "";
		display: block;
		position: absolute;
		width: 2px;
		height: 24px;
		background: #cccccc;
		left: 0;
		top: 5px;
		bottom: 5px;
	}
	
</style>



// WEBPACK FOOTER //
// resources/site/js/components/match-it.vue